module.exports = __webpack_public_path__ + "img/loader.f998db79.svg";